module.exports = __webpack_public_path__ + "img/electronic_no_zone_selected.513b8eec.svg";